var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15817 1.65869V5.42168H0V16.3876H12.1774V14.1371H14.8226V16.3875H27V5.42168H19.8407V1.65869H7.15817ZM9.10343 3.60395H17.8954V5.42168H9.10343V3.60395ZM0 18.4992V25.3413H27V18.4992H14.8226V20.6731H12.1774V18.4992H0Z",
    fill: "#00C8A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbox);
export default __webpack_public_path__ + "static/media/Toolbox.48c36148f9760e6b4094c40f40513791.svg";
export { ForwardRef as ReactComponent };